import {GoogleMapPin} from 'components/icons/GoogleMapPin';
import React from 'react';
import {ResidenceType, StageStatus} from 'features/search/filters/enums';

import './style.scss';

interface Props {
    lat: number;
    lng: number;
    stageStatus?: StageStatus;
    residenceType?: ResidenceType;
}

export const SimpleMarker: React.FunctionComponent<Props> = ({lat: _lat , lng: _lng, stageStatus, residenceType}) => {
    return (
        <GoogleMapPin onClick={() => {}} stageStatus={stageStatus} residenceType={residenceType} active={false} />
    );
};
